// import Swiper JS
import Swiper from "swiper";
// import 'swiper/css';

import { Autoplay, Navigation, EffectFade, Pagination } from "swiper/modules";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

indexInit();

/**
 * 首頁初始化
 */
function indexInit() {
  indexSwiper();
  index_partner();
}

/**
 * 首頁輪播圖
 */
function indexSwiper() {
  // 多款地板選擇輪播圖
  const swiperIndexFlooring = new Swiper(".swiper__indexFlooring", {
    modules: [Navigation],
    slidesPerView: 1,
    breakpoints: {
      576: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4,
      },
    },

    spaceBetween: 0,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  const swiperIndexBanner = new Swiper(".swiper__indexBanner", {
    modules: [Autoplay, EffectFade, Pagination],
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    preventClicks: false, // 不阻擋點擊
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 2000,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    on: {
      slideChange: function (e) {
        const realIndex = e.realIndex;
        const activeLink = document.querySelector(
          `[data-id="bannerSlide-${realIndex}"]`
        );

        const bannerLinkGroup = document.querySelectorAll(
          `[data-type="banner-slide"]`
        );
        bannerLinkGroup.forEach((link) => {
          link.classList.add("pointer-events-none");
        });
        if (activeLink) {
          activeLink.classList.remove("pointer-events-none");
        }
      },
    },
  });
}

/**
 * 首頁合作廠商效果
 */
function index_partner() {
  const clients_section = document.querySelectorAll(".clients_section");
  const partnerParent = document.querySelector(`[data-id="partner-parent"]`);

  gsap.registerPlugin(ScrollTrigger);
  let matchMedia = gsap.matchMedia();

  matchMedia.add(
    {
      isDesktop: `(min-width:576px)`,
      isMobile: `(max-width:576px)`,
      reduceMotion: `(prefers-reduced-motion:reduce)`,
    },
    (context) => {
      let { isDesktop, isMobile, reduceMotion } = context.conditions;
      let win_width = window.innerWidth;
      let length = clients_section.length;
      let num = 0;
      if (win_width > 768) {
        num = Math.ceil(length / 3) * 300;
      } else {
        num = Math.ceil(length / 2) * 300;
      }
      let sections = gsap.utils.toArray(".partner-container");

      let sections_width = sections[0].scrollWidth;
      let left = (win_width * 15.41) / 100;
      let width_final =
        sections_width - (win_width - left) + (win_width * 10) / 100;
      let end = "+=" + num;
      if (width_final >= 0) {
        width_final = -width_final;
      } else {
        width_final = 0;
      }
      const timeline = gsap.timeline();

      if (isDesktop) {
        timeline.to(sections, {
          // xPercent: -100 * (sections.length - 1),
          x: width_final,
          ease: "none",
          scrollTrigger: {
            start: "15% 35%",
            trigger: partnerParent,
            pin: true,
            // pinSpacing: false,
            scrub: 0.1,
            snap: 1 / (sections.length - 1),
            // markers: true,
            invalidateOnRefresh: true,
            // base vertical scrolling on how wide the container is so it   feels more natural.
            // end:"bottom 1%",
            end: end,
          },
        });
      }
    }
  );
}
